// extracted by mini-css-extract-plugin
export default {"avatar":"UserAvatar_avatar__OtQzi","placeholder":"UserAvatar_placeholder__DiAZU"};